// extracted by mini-css-extract-plugin
export default {"header":"header_header__qpVUA","container":"header_container__-NbND","logo":"header_logo__yCMqe","label":"header_label__+Ejpq"};